import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createCushionChargePolicy } from 'api/company/createCushionChargePolicy'
import { cushionChargePoliciesKey } from './keys'

type UseCreateCushionChargePolicyMutationRequest = Omit<
  Parameters<typeof createCushionChargePolicy>[0],
  'companyId'
>

export function useCreateCushionChargePolicyMutation(companyId: number) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (request: UseCreateCushionChargePolicyMutationRequest) =>
      createCushionChargePolicy({ companyId, ...request }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: cushionChargePoliciesKey(companyId),
      })
    },
  })
}
